import axios from 'axios'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Métodos de comunicación
    communicationMethods: {
      tableData: [],
      totalMethods: 0
    },
    queryCommunicationMethods: {
      page: 0,
      size: 20,
      sort: 'name,ASC',
      id: null,
      name: null,
      docTypeName: null,
      description: null,
      creationDateTimeFrom: null,
      creationDateTimeTo: null,
      enable: null 
    },
    listSelectedFiltersCommunicationMethods: [],
    docTypeOptions: []
  }
  return session
}
function setByUserLocalCommunicationMethod () {
  const local = {
    isShowName: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).communicationMethod.isShowName,
    isShowEnable: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).communicationMethod.isShowEnable,
    isShowDocumentType: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).communicationMethod.isShowDocumentType,
    isShowDescription: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).communicationMethod.isShowDescription,
    isShowCreationDateTime: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).communicationMethod.isShowCreationDateTime
  }
  return local
}

const state = {
  userConfigLocalStorage: '',
  local: {
    isShowName: true,
    isShowEnable: true,
    isShowDocumentType: true,
    isShowDescription: true,
    isShowCreationDateTime: true
  },
  session: initSession()
}

const getters = {
  queryCommunicationMethods: state => state.session.queryCommunicationMethods,
  communicationMethods: state => state.session.communicationMethods,
  listSelectedFiltersCommunicationMethods: state => state.session.listSelectedFiltersCommunicationMethods,
  isShowName: state => state.local.isShowName,
  isShowEnable: state => state.local.isShowEnable,
  isShowDocumentType: state => state.local.isShowDocumentType,
  isShowDescription: state => state.local.isShowDescription,
  isShowCreationDateTime: state => state.local.isShowCreationDateTime,
  docTypeOptions: state => state.session.docTypeOptions
}

const actions = {
  setUserNameCommunicationMethod ({ state }) {
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalCommunicationMethod()
    }
  },

  async isNewVersionCommunicationMethodLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.communicationMethod)
    return isnew
  },
  async getCommunicationMethods ({
    commit, rootState
  }, data) {
    try {
      const page = data.query.page || 0
      const size = data.query.size || 20
      const sort = data.query.sort || 'name,ASC'
      const filters = {
        id: data.query.id || null,
        name: data.query.name || null,
        docTypeName: data.query.docTypeName || null,
        description: data.query.description || null,
        creationDateTimeFrom: data.query.creationDateTimeFrom || null,
        creationDateTimeTo: data.query.creationDateTimeTo || null,
        enabled: typeof data.query.enable === 'boolean' ? data.query.enable : null
      }
      const response = await axios({
        method: 'POST',
        url: '/deliveryMethods',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: { page, size, sort },
        data: filters
      })
      commit('COMMUNICATION_METHODS_STATE', {
        tableData: response.data.content,
        totalMethods: response.data.totalElements
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('getCommunicationMethods: ', error.response)
      throw error.response
    }
  },
  async updateEnableCommunicationMethod({ commit, rootState }, { id, enable }) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/deliveryMethods/${id}/enable`,
        data: { enable }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.error('updateEnableCommunicationMethod error:', error.response || error)
      throw error.response || error
    }
  },
  async getDocTypeOptions({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/documenttype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      commit('DOC_TYPE_OPTIONS_STATE', response.data)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('getDocTypeOptions: ', error.response)
      throw error.response
    }
  },

  communicationMethodsState: ({ commit }, payload) => {
    commit('COMMUNICATION_METHODS_STATE', payload)
  },
  queryCommunicationMethodsState: ({ commit }, payload) => {
    commit('QUERY_COMMUNICATION_METHODS_STATE', payload)
  },
  listSelectedFiltersCommunicationMethodsState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_COMMUNICATION_METHODS_STATE', payload)
  },
  isShowNameAction: ({ commit }, payload) => {
    commit('IS_SHOW_NAME', payload)
  },
  isShowEnableAction: ({ commit }, payload) => {
    commit('IS_SHOW_ENABLE', payload)
  },
  isShowDocumentTypeAction: ({ commit }, payload) => {
    commit('IS_SHOW_DOCUMENT_TYPE', payload)
  },
  isShowDescriptionAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCRIPTION', payload)
  },
  isShowCreationDateTimeAction: ({ commit }, payload) => {
    commit('IS_SHOW_CREATION_DATE_TIME', payload)
  }
}

const mutations = {
  'QUERY_COMMUNICATION_METHODS_STATE' (state, payload) {
    state.session.queryCommunicationMethods = payload
  },
  'COMMUNICATION_METHODS_STATE' (state, payload) {
    state.session.communicationMethods = payload
  },
  'LIST_SELECTED_FILTERS_COMMUNICATION_METHODS_STATE' (state, payload) {
    state.session.listSelectedFiltersCommunicationMethods = payload
  },
  'IS_SHOW_NAME' (state, payload) {
    state.local.isShowName = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.communicationMethod.isShowName = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ENABLE' (state, payload) {
    state.local.isShowEnable = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.communicationMethod.isShowEnable = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DOCUMENT_TYPE' (state, payload) {
    state.local.isShowDocumentType = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.communicationMethod.isShowDocumentType = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCRIPTION' (state, payload) {
    state.local.isShowDescription = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.communicationMethod.isShowDescription = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CREATION_DATE_TIME' (state, payload) {
    state.local.isShowCreationDateTime = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.communicationMethod.isShowCreationDateTime = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'DOC_TYPE_OPTIONS_STATE'(state, payload) {
    state.session.docTypeOptions = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

